'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormatInfo;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactIntl = require('react-intl');

var _callNumber = require('@bibliocommons/call-number');

var _callNumber2 = _interopRequireDefault(_callNumber);

var _sharedEdition = require('@bibliocommons/shared-edition');

var _sharedEdition2 = _interopRequireDefault(_sharedEdition);

var _sharedPrimaryLanguage = require('@bibliocommons/shared-primary-language');

var _sharedPrimaryLanguage2 = _interopRequireDefault(_sharedPrimaryLanguage);

var _sharedPublicationDate = require('@bibliocommons/shared-publication-date');

var _sharedPublicationDate2 = _interopRequireDefault(_sharedPublicationDate);

require('../styles/FormatInfo.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormatInfo(_ref) {
  var item = _ref.item,
      className = _ref.className,
      showEdition = _ref.showEdition,
      showLanguage = _ref.showLanguage,
      showCallNumber = _ref.showCallNumber;

  var format = item.getIn(['briefInfo', 'format']);
  var publicationDate = item.getIn(['briefInfo', 'publicationDate']);
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('cp-format-info', className) },
    _react2.default.createElement(
      'div',
      { className: 'format-info-main-content' },
      _react2.default.createElement(
        'span',
        { className: 'cp-format-indicator', 'data-test-id': 'format-indicator' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FORMAT.' + format.toLowerCase() })
      ),
      publicationDate && _react2.default.createElement(_sharedPublicationDate2.default, { publicationDate: publicationDate }),
      showEdition && _react2.default.createElement(_sharedEdition2.default, { edition: item.getIn(['briefInfo', 'edition']) }),
      showLanguage && _react2.default.createElement(_sharedPrimaryLanguage2.default, { bib: item })
    ),
    showCallNumber && _react2.default.createElement(_callNumber2.default, { callNumber: item.getIn(['briefInfo', 'callNumber']) })
  );
}

FormatInfo.displayName = 'FormatInfo';

FormatInfo.propTypes = {
  item: _reactImmutableProptypes2.default.map.isRequired,
  className: _react.PropTypes.string,
  showEdition: _react.PropTypes.bool,
  showLanguage: _react.PropTypes.bool,
  showCallNumber: _react.PropTypes.bool
};

FormatInfo.defaultProps = {
  showLanguage: true
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-format-info/lib/components/FormatInfo.component.js
// module id = 1484
// module chunks = 1